<template>
  <div>
    <label
      v-if="label"
      class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
    >
      {{ label }}
    </label>
    <div :class="{ 'pointer-events-none opacity-50': disabled }">
      <SelectInput
        :model-value="modelValue"
        :options="classOptions"
        placeholder="None"
        @update:model-value="onChange"
      >
        <template #selected="{ option }">
          <span class="flex items-center gap-2">
            <i
              v-if="option.qboStatus"
              :class="statusIconClasses(option.qboStatus)"
            />
            <span>{{ option.label }}</span>
          </span>
        </template>
        <template #option="{ option }">
          <span class="flex items-center gap-2">
            <i
              v-if="option.qboStatus"
              :class="statusIconClasses(option.qboStatus)"
            />
            <span>{{ option.label }}</span>
          </span>
        </template>
      </SelectInput>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useStore } from "vuex";

import SelectInput from "@/components/Seranova/SelectInput/SelectInput.vue";
import type {
  AccountingClass,
  AccountingClassStatus
} from "@/typings/accounting";

withDefaults(
  defineProps<{
    modelValue: number | null;
    label?: string;
    disabled?: boolean;
  }>(),
  {
    label: "",
    disabled: false
  }
);

const emit = defineEmits<{
  "update:modelValue": [value: number | null];
}>();

const store = useStore();

const activeClasses = computed<AccountingClass[]>(() => {
  const classes = store.state.accountingClasses;
  if (!classes) return [];
  return Object.values(classes).filter((ac: AccountingClass) => !ac.archived);
});

const classOptions = computed(() =>
  activeClasses.value.map((ac) => ({
    label: ac.name,
    value: ac.id,
    qboStatus: ac.qbo_status
  }))
);

const statusIconClasses = (status: AccountingClassStatus) => {
  switch (status) {
    case "verified":
      return "fa-regular fa-check-circle text-green-600";
    case "inactive":
      return "fa-regular fa-circle-minus text-gray-400";
    case "verifying":
      return "far fa-circle-notch fa-spin text-yellow-600";
    default:
      return "fa-regular fa-exclamation-triangle text-yellow-600";
  }
};

const onChange = (val: number | null) => {
  emit("update:modelValue", val);
};
</script>
